import React, { useContext, useEffect, useRef, useState } from "react";
import "./login.scss";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import PlatformFooter from "../../../src/components/footer/footer";
import ReCAPTCHA from "react-google-recaptcha";
import { Controller, useForm } from "react-hook-form";
import { Layout } from 'antd';
import ChangePassword from "../../screens/changePassword/changePassword";
import { UrlConstants } from "../../utils/ApiConstants";
import axios from "axios";
import { Notification } from "../../components/notification/notification";
import CustomIcon from "../../components/icons/CustomIcon";
import { ReactComponent as LoginLoader } from "../../components/icons/login-loader-icon.svg";
import { Slide, ToastOptions, toast } from 'react-toastify';
import { getEncodedPassword } from "../../utils/utils";
import { MenuContext } from "../../MenuProvider";
import { GetRequest } from "../../utils/api";
import { authApis } from "../../utils/ApiURLs";
import { isTokenExpired } from "../../utils/object";
import { getImage } from "../../utils/getFile";
interface Props {
  isLogin?: (val: any) => void;
}

const removeSpaces = (value: any) => {
  return value.replace(/\s/g, ''); // Replace all spaces with empty strings
};

const { Content } = Layout;



const Login: React.FC<Props> = () => {

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { menuItems, setMenuItems } = useContext(MenuContext);

  const submitForm = async (values: any) => {

    if (captcha) {

      setIsSubmitted(true);
      setCaptchaError(false);

      try {

        const response = axios.post(`${UrlConstants.BASE_URL}${authApis.loginApi}`,
          { username: values.email, password: getEncodedPassword(values.password) },
          {
            headers: {
              "Content-Type": "application/json",
            }
          });

        response.then((loginResponse: any) => {



          localStorage.setItem("user", JSON.stringify(loginResponse.data));

          if (loginResponse.status === 200) {

            GetRequest('users/menulinks').then((menuResponse: any) => {
              setMenuItems(menuResponse.records);
              setData(loginResponse);
            });

            Notification('success', 'Login Successful');
          } else {
            Notification('error', loginResponse.data.error);
          }

          setIsSubmitted(false);

        }).catch((error) => {

          setIsSubmitted(false);

          if (error.response.data.error === "PASSWORD_RESET_FIRST_TIME_USER" || error.response.data.error === "PASSWORD_EXPIRED") {
            setPasswordChangeRequired(true);
          }

          if (error.response.data.error === "USER_BLOCKED") {
            Notification('error', error.response.data.errorMessage);
            return;
          }

          Notification('error', error.response.data.error);

        });

      } catch (error) {
        Notification('error', "Failed to Login");
      }

    } else {
      setCaptchaError(true);
    }
  };



  useEffect(() => {

    if (menuItems === null || menuItems === undefined || menuItems.length === 0) {
      if (localStorage.getItem("user") != null && isTokenExpired(JSON.parse(localStorage.getItem("user") || "{}")?.accessToken)) {
        if (menuItems.length > 0) {
        } else {
          GetRequest('users/menulinks').then((res) => {
            if (res && res.records.length > 0) {
              setMenuItems(res.records);
            }
          });
        }
      }
    }
  }, []);

  const [captcha, setcaptcha] = useState(null);
  const [captchaError, setCaptchaError] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState(false); // State variable to track form submission
  const [isPasswordChangeRequired, setPasswordChangeRequired] = useState(false);
  const recaptchaKey = useRef<string>(process.env.REACT_APP_RECAPTCHA_KEY as string);

  if (window.location.hostname === process.env.REACT_APP_BASE_URL_UAT || window.location.hostname === "localhost") {
    recaptchaKey.current = process.env.REACT_APP_RECAPTCHA_DEMO_KEY as string;
  }

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();


  const [data, setData] = useState<any>({});

  function onChange(value: any) {
    form.setFieldsValue({ recaptcha: value });
    setcaptcha(value);
  }

  function changePasswordOnFirstogin(data: any) {


    const Headers: any = {
      'Content-Type': 'application/json'
    };

    const url = `${UrlConstants.BASE_URL}${authApis.changePasswordApi}`;
    axios.post(url, data, {
      headers: Headers
    }).then(() => {
      setPasswordChangeRequired(false);
      Notification("success", "Password updated successfully, please login with new password.");
    }).catch(() => {
      Notification("error", "Failed to  update the  password, please contact admin.");
    });
  }


  // Navigate to login only on success....
  useEffect(() => {

    if (data.data && data.data.accessToken && data.data.accessToken.length > 0) {

      if (data.data.passwordExpiryDays <= 5) {
        let config: ToastOptions = {
          className: "toast-custom-warning",
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        };

        toast.warning(<div className="banner">
          <p className="banner-text">
            Your password will expire in <strong>{data.data.passwordExpiryDays} days</strong>. Please{" "}
            <a style={{
              color: "blue",
              textDecoration: "underline",
            }} onClick={() => navigate("/changePassword")}>
              change your password
            </a>{" "}
            to ensure uninterrupted access.
          </p>
        </div>, config);
      }

      if (menuItems && menuItems.length > 0) {
        navigate(`/${menuItems[0].mainMenuCode}`);
      } else { //Fall back case to avoid error on logging in
        GetRequest('users/menulinks').then((res) => {
          if (res && res.records.length > 0) {
            setMenuItems(res.records);
            navigate(`/${res.records[0].mainMenuCode}`);
          }
        });
      }


    }
  }, [data.data]);

  //For testing automation purpose only - bypassing captcha
  useEffect(() => {
    let w: any = window;
    if (w.Cypress) {
      let val = "Captcha-Completed"
      onChange(val);
    }
  });

  return (

    <Layout style={{ height: "100vh" }}>

      <Layout style={{ height: "100%" }}>

        <Content>

          <div className="login-container">
            <div className="login-aside">
              <h1>Bharat Collect</h1>
            </div>
            <div className="login-auth">
              <div className="login-header-logo">
                <img style={{ height: "auto", width:"80%" }} src={getImage('logo.png')} alt="Bharat collect logo" />
              </div>
              <div className="loginCard">
                {isPasswordChangeRequired ? <ChangePassword title="Please change password to proceed." submitCallBack={changePasswordOnFirstogin} username={getValues("email")} currentPassword={getValues("password")}></ChangePassword> :
                  <form onSubmit={handleSubmit(submitForm)}>
                    <div style={{ textAlign: "left" }}>
                      <div>
                        <div className="my-1"><label>Username</label></div>
                        <Controller
                          name="email"
                          control={control}
                          rules={{
                            required: 'Username is required',
                            // pattern: {
                            //   value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            //   message: 'Invalid email address',
                            // },
                          }}
                          render={({ field }) => <Input type="text" maxLength={50}
                            {...field}
                            onChange={(e) => field.onChange(removeSpaces(e.target.value))}
                          />}
                        />
                        {errors.email && <p className="ant-form-item-explain-error">{errors.email.message?.toString()}</p>}
                      </div>
                      <div>
                        <div className="mb-1 mt-3"><label>Password</label></div>
                        <Controller
                          name="password"
                          control={control}
                          rules={{ required: 'Password is required' }}
                          render={({ field }) => <Input.Password type="password" {...field}
                            onChange={(e) => field.onChange(removeSpaces(e.target.value))} />}
                        />
                        {errors.password && <p className="ant-form-item-explain-error"> {errors.password.message?.toString()} </p>}
                      </div>
                      <div className="forgot-link mt-2">
                        <a
                          href="javascript:void"
                          onClick={() => navigate("/forgotpassword")}
                        >
                          Forgot password?
                        </a>
                      </div>
                      <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                      }}>
                        <ReCAPTCHA //6LeBV4MpAAAAADacZ7OdJJYtN4Ct2f5B9QeeDiRc
                          sitekey={recaptchaKey.current}
                          onChange={(value) => { onChange(value); }}
                          size={'normal'}
                        />
                      </div>
                      {captchaError && <p className="ant-form-item-explain-error text-center my-2">Please verify yourself</p>}
                    </div>

                    <div className="btn-container">
                      <Button block size="large" style={{ height: "44px" }}
                        icon={<span className="align-top"> {isSubmitted ? <LoginLoader height="32px" width="32px" className="mr-2" ></LoginLoader> : <CustomIcon height="22px" width="22px" className="mr-2" name="login"></CustomIcon>} </span>}
                        id="login-button" type="primary" htmlType="submit" className="mt-2 login-btn">
                        <span className="align-top text-lg"> {isSubmitted ? "Logging In" : "Login"}</span>
                      </Button>
                    </div>
                  </form>}

              </div>
            </div>
          </div>

        </Content>
      </Layout>

      <PlatformFooter />
    </Layout>


  );
};

export default Login;